import { render, staticRenderFns } from "./FormInputGroupDropdown.vue?vue&type=template&id=60fa634a&"
import script from "./FormInputGroupDropdown.vue?vue&type=script&lang=js&"
export * from "./FormInputGroupDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports